/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CardInactive: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 4C3.79086 4 2 5.79086 2 8V16C2 18.2091 3.79086 20 6 20H12C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18H6C4.89543 18 4 17.1046 4 16V8C4 6.89543 4.89543 6 6 6H18C19.1046 6 20 6.89543 20 8V10C20 10.5523 20.4477 11 21 11C21.5523 11 22 10.5523 22 10V8C22 5.79086 20.2091 4 18 4H6ZM7 10C7 9.44772 7.44772 9 8 9H10C10.5523 9 11 9.44772 11 10C11 10.5523 10.5523 11 10 11H8C7.44772 11 7 10.5523 7 10ZM17.2071 13.7929C16.8166 13.4024 16.1834 13.4024 15.7929 13.7929C15.4024 14.1834 15.4024 14.8166 15.7929 15.2071L17.5858 17L15.7929 18.7929C15.4024 19.1834 15.4024 19.8166 15.7929 20.2071C16.1834 20.5976 16.8166 20.5976 17.2071 20.2071L19 18.4142L20.7929 20.2071C21.1834 20.5976 21.8166 20.5976 22.2071 20.2071C22.5976 19.8166 22.5976 19.1834 22.2071 18.7929L20.4142 17L22.2071 15.2071C22.5976 14.8166 22.5976 14.1834 22.2071 13.7929C21.8166 13.4024 21.1834 13.4024 20.7929 13.7929L19 15.5858L17.2071 13.7929Z'
      fill='currentColor'
    />
  </React.Fragment>
)
